'use client';

import { c as _c } from "react/compiler-runtime";
import { type Post } from '@shared/all/domains/posts';
import usePostsShared from '@shared/utils/hooks/usePosts';
import Link from 'next/link';
import { client } from '../../utils/trpc';
import ReplyItem from './ReplyItem';
type Props = {
  post: Post;
  isFullLength: boolean;
  disableLink: boolean;
  isPoliticsParent?: boolean;
  isNsfwParent?: boolean;
  threadId?: string;
  uniqueId?: string;
};
const ReplyContainer = props => {
  const $ = _c(15);
  const {
    fetchPostReplies
  } = usePostsShared(client, props.uniqueId);
  const hasMore = props.post.replies_count - (props.post.replies?.length || 0) > 0;
  let t0;
  if ($[0] !== props.post.id || $[1] !== props.post.isPrivate || $[2] !== props.threadId) {
    t0 = props.threadId && <div className="flex flex-row items-center space-x-2"><Link href={props.post.isPrivate ? `/private-post/${props.threadId}` : `/post/${props.threadId}`}><h1 className="text-sm text-primary">View Parent Thread</h1></Link><hr className="flex-1 border-ds-border-standard" /><Link href={props.post.isPrivate ? `/private-post/${props.post.id}` : `/post/${props.post.id}`}><h1 className="text-sm text-primary">See Full Discussion</h1></Link></div>;
    $[0] = props.post.id;
    $[1] = props.post.isPrivate;
    $[2] = props.threadId;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== props) {
    t1 = props.post.replies_count > 0 && <div className="mt-4 w-full rounded-md bg-background-secondary py-4 pl-2 pr-4 shadow-lg">{props.post.replies?.map(reply => <ReplyItem key={reply.id} {...props} post={reply} currentLevel={0} isPoliticsParent={props.isPoliticsParent} isNsfwParent={props.isNsfwParent} isFullLength={props.isFullLength} />)}</div>;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== fetchPostReplies || $[7] !== hasMore || $[8] !== props.post.id || $[9] !== props.threadId) {
    t2 = !props.threadId && hasMore && <button onClick={() => fetchPostReplies(props.post.id)} type="button" className="m-2 text-textSecondary/50">Load more replies</button>;
    $[6] = fetchPostReplies;
    $[7] = hasMore;
    $[8] = props.post.id;
    $[9] = props.threadId;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== t0 || $[12] !== t1 || $[13] !== t2) {
    t3 = <div className="w-full space-y-2 pt-2">{t0}{t1}{t2}</div>;
    $[11] = t0;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
export default ReplyContainer;